export default __webpack_public_path__ + "static/media/zoom-out.1fba2cb9.svg";